module.exports = __webpack_public_path__ + "img/info-circle.ac929837.svg";